// import tabList from './tabList';
import tabListSplide from './tabListSplide';

const resultList = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
		this.initFilters();
	},

	bindUI: function() {
		// console.log("bindUI");
		this.ui.lock = false;

		this.ui.$resultListContainer = $('.js-resultList__container');
		this.ui.$resultListAjaxContainer = $('.js-resultList-ajax-container');
		this.ui.$resultListForm = $('.js-resultList-form');
		this.ui.$resultListInput = $('.js-resultList-input');
		this.ui.$resultListFilter = $('.js-resultList-filter-input');

		this.ui.filtersContainer = ".js-filters-container";
		this.ui.filterSelectedContainer = ".js-filterSelected-container";
		this.ui.$filterSelectedContainer = $(this.ui.filterSelectedContainer);
		this.ui.filterSelected__reset = ".js-filterSelected__reset";
		this.ui.$filterSelected__reset = $(this.ui.filterSelected__reset);
	},

	bindEvents: function() {
		this.ui.$resultListForm.on('submit', this.onSubmit.bind(this));;
		this.ui.$resultListInput.on('change', this.onChangeInput.bind(this));
		this.ui.$resultListFilter.on('change', this.onChangeFilter.bind(this));

		this.ui.$filterSelectedContainer.on('click', '.js-filterSelected__delete', this.removeFilter.bind(this))
		this.ui.$filterSelected__reset.unbind('click')
		this.ui.$filterSelected__reset.on('click', this.resetFilters.bind(this))
	},

	onChangeInput: function(e){
		this.ui.$resultListForm.submit();
	},
	onChangeFilter: function(e){
		let $this = $(e.currentTarget);
		this.handleFilter($this);
	},

	handleFilter: function($filterInput){
		console.log("handleFilter");
		this.updateFilters();
	},

	initFilters: function(){
		this.updateFilters();
	},

	removeFilter: function(e){
		let $this = $(e.currentTarget);
		let $currentFilter = $this.closest(".js-filterSelected");
		$("[id='"+$currentFilter.attr("data-linked-filter")+"']").prop("checked", false).change();
	},

	resetFilters: function(){
		this.ui.$filterSelectedContainer.find('.js-filterSelected__delete').click();
	},

	updateFilters: function(){
		$(".js-filterSelected").remove();
		this.ui.$resultListFilter.map((index, filterInput)=>{
			let $filterInput = $(filterInput);
			if($filterInput && $filterInput.is(":checked") ){
				if($("[data-linked-filter='"+$filterInput.attr("id")+"']")){
					let nameFilter = $filterInput.closest(".js-resultList-filter").find(".js-resultList-filter-label").text();
					let $newFilter = $filterInput.closest(this.ui.filtersContainer).find(".js-filterSelected-tpl").clone();
					$newFilter.removeClass("js-filterSelected-tpl")
							  .removeClass("js-hide")
							  .addClass("js-filterSelected")
							  .attr("data-linked-filter", $filterInput.attr("id"))
					$newFilter.find(".js-filterSelected-name").text(nameFilter);
					$filterInput.closest(this.ui.filtersContainer).find(this.ui.filterSelectedContainer).append($newFilter);
				}
			}
		});
		$(".js-filterSelected-count").text($(".js-filterSelected").length)
		let that = this;
		$(".js-filterSelected").each(function(){
			let $filterSelected__reset = $(this).closest(that.ui.filtersContainer).find(that.ui.filterSelected__reset);
			if($(this).length > 0){
				$filterSelected__reset.removeClass("js-hide");
			}else{
				$filterSelected__reset.addClass("js-hide");
			}
		});
	},

	onSubmit: function(e){
		let that = this
		e.preventDefault();
		let $form = that.ui.$resultListForm
		,	ajaxTargetUrl = $form.attr("action")
		,	serializedArrayForm = $form.serializeArray();
		// generate ajax params from form
			var JSONparams = {}
			for (var i = 0; i < serializedArrayForm.length; i++) {
				JSONparams[serializedArrayForm[i].name] = serializedArrayForm[i].value;
			}
		// maj URL with form params (for GET form)
			let newUrl = "?";
			for (var i = 0; i < serializedArrayForm.length; i++) {
				if(i!=0){
					newUrl += "&";
				}
				newUrl += serializedArrayForm[i].name+"="+serializedArrayForm[i].value;
			}
			if(window.location.hash){
				newUrl += window.location.hash;
			}
			if(history && history.pushState){//on vérifie si le navigateur supporte la navigation par historique
				history.pushState({page: newUrl}, newUrl, newUrl);//on écrit dans l'historique, on modifie l'url
			}
	
		that.ui.lock = true;
		$("html").addClass("loading");
		that.ui.$resultListAjaxContainer.addClass("loading");
		// post or get
		if(that.currentajax){
			that.currentajax.abort();
		}
		that.currentajax = $.get(
			ajaxTargetUrl,
			serializedArrayForm,
			// or 
			// {
			// 	'param1' : 'param1Value',
			// 	'param2' : 'param2Value',
			// },
			function(response){}
		).done(function(response) {
			that.ui.$resultListContainer.find(".js-popin-close").click();
			that.ui.$resultListContainer.html(response.html);
			
			that.init();

			// $(".js-tabList").each(function(){
			// 	let tab = new tabList();
			// 	tab.init($(this));
			// });
			$(".js-tabListSplide").each(function(){
				let tab = new tabListSplide();
				tab.init($(this));
			});
		})
		.fail(function(response) {
			$form.addClass("has-error")
		})
		.always(function(response) {
			$("html").removeClass("loading");
			that.ui.$resultListAjaxContainer.removeClass("loading");
			that.ui.lock = false;
		});
	}

};

module.exports = resultList;